import moment from 'moment-timezone'
import KosherZmanim from 'kosher-zmanim'
import ZmanimListEntry from './zmanimListEntry'
import ZmanimListHeader from './zmanimListHeader'

const HebrewDateFormatter = KosherZmanim.lib.HebrewDateFormatter
const JewishDate = KosherZmanim.lib.JewishDate

const DEFAULT_FILTERS = [
  'Alos72',
  'Sunrise',
  'SofZmanShmaGRA',
  'SofZmanShmaMGA',
  'SofZmanTfilaGRA',
  'SofZmanTfilaMGA',
  'Chatzos',
  'PlagHamincha',
  'MinchaGedola',
  'MinchaKetana',
  'Sunset',
  'Tzais72'
]
export default class ZmanimList {
  constructor (initialLocation, filters = DEFAULT_FILTERS) {
    this.location = initialLocation
    this.filters = filters
  }

  get zmanim () {
    if (!this.location) {
      return {}
    }

    const options = this.location.options
    const zmanim = new KosherZmanim(options)
    const json = zmanim.getZmanimJson()
    return json
  }

  get items () {
    return this.headerItems.concat(this.zmanimItems)
  }

  get headerItems () {
    const formatter = new HebrewDateFormatter(this.location.timeZone)
    const jewishDate = new JewishDate(new Date())
    const subtitle = `${formatter.format(jewishDate)}`
    const header = new ZmanimListHeader({
      title: 'Today',
      subtitle
    })
    return [header]
  }

  timeFromString = function timeFromString (format) {
    const m = moment(format)
    const time = m.format('h:mma')
    return time
  };

  titleFromKey = function titleFromKey (key) {
    const titles = {
      Alos72: 'Alos',
      Sunrise: 'Sunrise',
      SofZmanShmaMGA: 'Sof Zman Shma',
      SofZmanShmaGRA: 'Sof Zman Shma',
      SofZmanTfilaMGA: 'Sof Zman Tfila',
      SofZmanTfilaGRA: 'Sof Zman Tfila',
      MinchaGedola: 'Mincha Gedola',
      MinchaKetana: 'Mincha Ketana',
      PlagHamincha: 'PlagHamincha',
      Tzais72: 'Tzais Hakochavim'
    }
    return titles[key] || key
  };

  subititleFromKey = function subititleFromKey (key) {
    const subtitles = {
      Alos72: '72 Minutes',
      SofZmanShmaMGA: 'Mogen Avraham',
      SofZmanShmaGRA: 'Vilna Gaon',
      SofZmanTfilaMGA: 'Mogen Avraham',
      SofZmanTfilaGRA: 'Vilna Gaon',
      Tzais72: '72 Minutes'
    }
    return subtitles[key]
  };

  get zmanimItems () {
    const zmanim = this.zmanim
    const basicZmanim = zmanim.BasicZmanim
    const filterZmanim = this.filters
    const keys = Object.keys(basicZmanim).filter(key =>
      filterZmanim.includes(key)
    )
    return keys
      .map(zman => {
        const timestamp = basicZmanim[zman]

        const time = this.timeFromString(timestamp)

        return new ZmanimListEntry({
          key: zman,
          title: this.titleFromKey(zman),
          subtitle: this.subititleFromKey(zman),
          time,
          date: moment(timestamp).toDate()
        })
      })
      .filter(zman => zman !== undefined)
  }

  zmanForKey = function zmanForKey (key) {
    return this.zmanimItems.find(item => item.key === key)
  };
}
